import React from 'react';
import { Base } from '../packages/react/src/components/default/Base/Base.mjs';

// Components
/**
 * Use `BaseWithoutSprite` as the root component of the loop system.
 */
const BaseWithoutSprite = ({ children }) => {
    return React.createElement(Base, { brand: "ee" }, children);
};

export { BaseWithoutSprite, BaseWithoutSprite as default };
//# sourceMappingURL=BaseWithoutSprite.mjs.map
